// extracted by mini-css-extract-plugin
export default {"container":"Head_container__5W1vB","containerSticking":"Head_containerSticking__Bh5ks"};